module.exports = __webpack_public_path__ + "img/victory.0746533f.png";